import React, { useState } from 'react'
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import OnioTabs from "../../Components/OnioTabs/index";
import Button from '@mui/material/Button';
import { Avatar, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import { HexColorPicker } from "react-colorful";
import CardMedia from '@mui/material/CardMedia';
import Card from '@mui/material/Card';
import Badge from '@mui/material/Badge';

import Locks from './Locks'
import GrageDoors from './GarageDoors'
import Gates from './Gates'
// import useMediaQuery from '@mui/material/useMediaQuery';

import './index.css'
import { lightsMenu, LightsType, TabMenus, Icons, AvatarStyle , cardStyle } from './style';


const SecurityPage = () => {

  // const matches = useMediaQuery('(max-width:1024px)');
  const [lightCard, setLightCard] = useState(0);
  const [tab, setTab] = useState<number>(0);

  const handleMenuNavigation = (ele: any, i: number) => {
    setTab(i)
  }
  const displayTabs = () => {
    switch (tab) {
      case 1:
        return (<Locks />)
      case 2:
        return (<GrageDoors />)
      case 3:
        return (<Gates />)
    }
  }
  return (
    <Container maxWidth="lg">
      <OnioTabs onClick={handleMenuNavigation} menu={TabMenus} />



      {tab === 0 ? (<>
        <Grid container spacing={2} sx={{ mt: 4 }}>
          <Grid sx={cardStyle} il={12}>
          <div className="lights-scroll">

            {
              lightsMenu.map((ele, i) => {
                return (
                  <LightsType onClick={() => setLightCard(i)} sx={{ backgroundColor: lightCard === i ? "#D4DD06 !important" : "#212121" }} className="lights-scroll-item" key={i}>
                    <Typography sx={{ color: lightCard === i ? "#1A1A1A" : "#FFFFFF", textTransform: "capitalize" }}>{ele.name}</Typography>
                    <Typography variant="caption" sx={{ color: lightCard === i ? "#FFFFFF" : "#909090" }}>{ele.type}</Typography>
                  </LightsType>
                )
              })
            }

          </div>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ mt: 4 }}>
          <Grid xs={12} >
            <Card sx={{ maxWidth: "100%" }}>
              <Badge badgeContent={100} color="secondary">
                <CardMedia
                  component="img"
                  image={Icons.Garage}
                  alt="green iguana"
                />
              </Badge>
            </Card>
          </Grid>
        </Grid> </>) : ""}

      {displayTabs()}

    </Container>

  )
}

export default SecurityPage